import React from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheck, GraduationCap, Award, Mic, Users, ShieldCheck, Star, ArrowRight } from 'lucide-react';
import { CLINIC_AGGREGATE_RATING } from '../data/structuredData';
import { doctifyData } from '../data/mock';
import './proof-strip.css';

const PROOF = [
  { icon: Award, strong: '15+ years', text: 'focused on TMD, headache & tinnitus' },
  { icon: GraduationCap, strong: 'Dual BSc (Hons)', text: 'Biomedical Science & Physiotherapy' },
  { icon: GraduationCap, strong: 'University of Liverpool', text: 'Masters module in TMD' },
  { icon: BadgeCheck, strong: 'Columbia University', text: 'Orofacial Pain Clinic placement' },
  { icon: BadgeCheck, strong: 'Specialist TMD training', text: 'Steve Kraus (Atlanta) · CRAFTA® · Watson Headache® · Instituto Rocabado' },
  { icon: Mic, strong: 'Invited lecturer', text: "UCL MSc Audiology" },
  { icon: Users, strong: 'Past committee member', text: 'ACPTMD' },
  { icon: ShieldCheck, strong: 'HCPC-registered', text: 'Chartered Society of Physiotherapy member' },
];

export default function ProofStrip({ variant = 'light' }) {
  return (
    <section className={`proof-strip proof-strip-${variant}`} aria-label="Krina Panchal's verified credentials" data-testid="proof-strip">
      <div className="proof-strip-inner">
        <div className="proof-strip-head">
          <p className="proof-strip-eyebrow">Verified credentials</p>
          <p className="proof-strip-ratings" data-testid="proof-strip-ratings">
            <Star size={14} fill="currentColor" aria-hidden="true" /> {CLINIC_AGGREGATE_RATING.ratingValue} on Google
            <span aria-hidden="true">·</span> {doctifyData.rating} on Doctify
          </p>
        </div>
        <ul className="proof-strip-list">
          {PROOF.map(({ icon: Icon, strong, text }) => (
            <li key={strong} className="proof-strip-item">
              <Icon size={16} aria-hidden="true" />
              <span><strong>{strong}</strong> {text}</span>
            </li>
          ))}
        </ul>
        <Link to="/the-tmd-physio-standard" className="proof-strip-link" data-testid="proof-strip-standard-link">
          Read The TMD Physio Standard <ArrowRight size={14} aria-hidden="true" />
        </Link>
      </div>
    </section>
  );
}
